import { render, staticRenderFns } from "./RouteButton.vue?vue&type=template&id=4bd36943"
import script from "./RouteButton.vue?vue&type=script&lang=js"
export * from "./RouteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports